<template>
    <app-layout>
        <template #header>
            
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <audit-table></audit-table>
            </div>
        </div>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import AuditTable from '@/components/AuditTable'

    export default {
        components: {
            AppLayout,
            AuditTable
        },
    }
</script>
